import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { UpgradeModule } from '@angular/upgrade/static';
import { Router } from '@angular/router';
import { AppModule } from './app.module';

function getSafariVersion() {
	const ua = navigator.userAgent;
	const tem = ua.match(/version\/(\d+)/i);
	let M =
		ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) ||
		[];
	if (M[2]) {
		M = [M[1], M[2]];
	} else {
		M = [navigator.appName, navigator.appVersion, '-?'];
	}
	if (tem != null) {
		M.splice(1, 1, tem[1]);
	}
	if (M[0] === 'Safari') {
		return parseInt(M[1]);
	}
	return 1000;
}

const isIE =
	navigator.userAgent.indexOf('MSIE ') > -1 ||
	navigator.userAgent.indexOf('Trident/') > -1;
const safariVersion = getSafariVersion();
const isNotSupportedBrowser =
	safariVersion < 9 || !Modernizr.flexbox || !Modernizr.sizes;

if (!isNotSupportedBrowser && !isIE) {
	platformBrowserDynamic()
		.bootstrapModule(AppModule)
		.then(platformRef => {
			const upgrade = platformRef.injector.get(UpgradeModule) as UpgradeModule;
			upgrade.bootstrap(document.body, ['main'], {
				strictDi: true
			});
			platformRef.injector.get(Router).initialNavigation();
		})

		.catch(err => console.error('Error on bootstrap => ', err));
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/main.ts